import { useCallback } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './featureHighlight.module.scss';

export default function FeatureHighlightItem({
  headline,
  bullets = '',
  index,
  isActive = false,
  onActivate,
}) {
  const handleActivate = useCallback(() => {
    onActivate(index);
  }, [onActivate, index]);

  return (
    <div className={styles.item} onMouseEnter={handleActivate}>
      <h3
        className={`${styles.itemHeadline} ${
          isActive ? styles.itemHeadlineActive : ''
        }`.trim()}
      >
        {headline}
      </h3>
      <div
        className={`${styles.itemBullets} ${
          isActive ? styles.itemBulletsActive : ''
        }`.trim()}
      >
        <div className={styles.itemBulletsInner}>{parse(bullets || '')}</div>
      </div>
    </div>
  );
}

FeatureHighlightItem.propTypes = {
  headline: PropTypes.string.isRequired,
  bullets: PropTypes.string,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onActivate: PropTypes.func.isRequired,
};
